<template>
  <div class="submenu w-100" data-test-id="submenu-links">
    <div
      v-for="_route in internal_tabs"
      class="nowrap"
      :data-test-id="`submenu-${_route.name}`"
      :key="_route.name"
    >
      <router-link
        v-if="!prevent_routing"
        :to="{ name: _route.name, params: route_params }"
        :class="{'active': [_route.name, _route.path].includes(current_route)}"
        class="d-block text-center"
      >
        {{ _route.title }}
      </router-link>
      <a
        v-else
        class="d-block text-center cursor-pointer"
        :class="{'active': [_route.name, _route.path].includes(current_route)}"
        @click="onTabClick(_route)"
      >
        {{ _route.title }}
      </a>
    </div>
  </div>
</template>

<script>
import original_routes from '../../router';
import { consoleUserCanAccessPageMiddleware } from '../../libs/helpers2';

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    routes: {
      type: Object,
      required: true
    },
    route_params: {
      type: Object
    },
    prevent_routing: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      internal_tabs: [],
      current_route: null
    };
  },
  async created() {
    this.internal_tabs = await this.verifyTabs();
    this.current_route = this.getActiveTab();
    if (this.prevent_routing) {
      this.$emit('input', this.current_route);
    }
  },
  methods: {
    async verifyTabs() {
      const allRoutes = this.$router
        ? this.$router.options.routes.filter((x) => Object.keys(this.routes).includes(x.name))
        : original_routes;

      const allowed = [];
      for (const name of Object.keys(this.routes)) {
        const route = allRoutes.find((x) => x.name === name);
        if (route && (await consoleUserCanAccessPageMiddleware(route, this.$branding, this.$session))) {
          allowed.push({
            ...this.routes[name],
            title: this.routes[name].title,
            name
          });
        }
      }
      return allowed;
    },
    getActiveTab() {
      const fallback = this.internal_tabs[0]?.name || null;
      const fromProp = this.value || (this.prevent_routing ? fallback : this.$route?.name);
      const found = this.internal_tabs.find((tab) => tab.name === fromProp);

      if (!found) {
        for (const tab of this.internal_tabs) {
          if (tab.subroutes?.includes(fromProp)) {
            tab.path = this.prevent_routing ? tab.name : this.$router.options.routes.find((x) => x.name === tab.name)?.path;
            return tab.name;
          }
        }
      }
      return found?.name || fallback;
    },
    onTabClick(tab) {
      this.current_route = tab.name;
      this.$emit('input', tab.name);
    },
  },
};
</script>

<style scoped>
.submenu {
  padding-bottom: 30px;
  padding-top: 20px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.submenu::-webkit-scrollbar {
  display: none;
}
.submenu > div {
  flex: 1 1 0;
  min-width: max-content;
  padding: 0 16px;
  white-space: nowrap;
  border-bottom: 1px solid rgba(133,146,154,.2);
}
.submenu > div > a {
  font-size: 14px;
  line-height: 18px;
  padding-bottom: 12px;
  color: #29921b;
  white-space: nowrap;
}
.submenu > div:has(> a.router-link-exact-active),
.submenu > div:has(> a.active) {
  border-bottom: 4px solid #2a9bb7 !important;
}
.submenu > div:has(> a.router-link-exact-active) > a,
.submenu > div:has(> a.active) > a {
  color: var(--v-text-base) !important;
}
</style>
